var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-media-preview",
      attrs: { "data-test": "media-preview" }
    },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "media-loading d-flex align-center justify-center pa-3 rounded"
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: "24",
                  width: "2",
                  color: "grey"
                }
              })
            ],
            1
          )
        : _vm.loadError
        ? _c(
            "div",
            { staticClass: "media-error d-flex align-center pa-2 rounded" },
            [
              _c("icon-svg", {
                staticClass: "mr-2",
                attrs: { name: _vm.errorIcon, size: "20", color: "grey" }
              }),
              _c("span", { staticClass: "az-text-secondary az-size-12" }, [
                _vm._v(_vm._s(_vm.errorMessage))
              ])
            ],
            1
          )
        : _vm.isSticker && _vm.blobUrl
        ? [
            _c("img", {
              staticClass: "media-sticker",
              attrs: { src: _vm.blobUrl, alt: _vm.mediaFilename || "Sticker" },
              on: { error: _vm.onMediaError }
            })
          ]
        : _vm.isImage && _vm.blobUrl
        ? [
            _c("img", {
              staticClass: "media-image rounded",
              attrs: { src: _vm.blobUrl, alt: _vm.mediaFilename || "Mídia" },
              on: { click: _vm.openLightbox, error: _vm.onMediaError }
            }),
            _vm.lightboxOpen
              ? _c(
                  "div",
                  {
                    staticClass: "lightbox-overlay",
                    attrs: { "data-test": "lightbox" },
                    on: { click: _vm.closeLightbox, keydown: _vm.onLightboxKey }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "lightbox-close",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.closeLightbox($event)
                          }
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: _vm.icons.close,
                            size: "28",
                            color: "#FFFFFF"
                          }
                        })
                      ],
                      1
                    ),
                    _c("img", {
                      staticClass: "lightbox-image",
                      attrs: {
                        src: _vm.blobUrl,
                        alt: _vm.mediaFilename || "Mídia"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                        }
                      }
                    })
                  ]
                )
              : _vm._e()
          ]
        : _vm.isAudio && _vm.blobUrl
        ? _c(
            "div",
            {
              staticClass:
                "media-audio-wrapper d-flex align-center pa-2 rounded",
              attrs: { "data-test": "media-audio" }
            },
            [
              _c("audio", {
                ref: "audio",
                staticClass: "media-audio-native",
                attrs: { src: _vm.blobUrl, preload: "metadata" },
                on: {
                  loadedmetadata: _vm.onAudioLoadedMetadata,
                  timeupdate: _vm.onAudioTimeUpdate,
                  ended: _vm.onAudioEnded,
                  error: _vm.onMediaError
                }
              }),
              _c(
                "v-btn",
                {
                  staticClass: "audio-play-btn mr-2 flex-shrink-0",
                  attrs: {
                    icon: "",
                    small: "",
                    "aria-label": _vm.audioPlaying ? "Pausar" : "Reproduzir"
                  },
                  on: { click: _vm.toggleAudioPlay }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: _vm.audioPlaying ? _vm.icons.pause : _vm.icons.play,
                      size: "18",
                      color: "var(--primary)"
                    }
                  })
                ],
                1
              ),
              _c("input", {
                staticClass: "audio-seek flex-grow-1",
                attrs: {
                  type: "range",
                  min: "0",
                  max: _vm.audioDuration || 0,
                  step: 0.1,
                  disabled: !_vm.audioDuration,
                  "aria-label": "Progresso do áudio"
                },
                domProps: { value: _vm.audioCurrentTime },
                on: { input: _vm.onAudioSeek }
              }),
              _c(
                "span",
                {
                  staticClass:
                    "audio-time az-text-secondary az-size-12 ml-2 flex-shrink-0"
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.audioCurrentTimeLabel) +
                      " / " +
                      _vm._s(_vm.audioDurationLabel) +
                      " "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "audio-rate-btn az-text-small font-medium ml-2 flex-shrink-0",
                  attrs: {
                    type: "button",
                    "aria-label": "Velocidade: " + _vm.audioPlaybackRateLabel
                  },
                  on: { click: _vm.cycleAudioRate }
                },
                [_vm._v(" " + _vm._s(_vm.audioPlaybackRateLabel) + " ")]
              )
            ],
            1
          )
        : _vm.isVideo && _vm.blobUrl
        ? _c(
            "video",
            {
              staticClass: "media-video rounded",
              attrs: { src: _vm.blobUrl, controls: "", preload: "metadata" },
              on: { error: _vm.onMediaError }
            },
            [_c("track", { attrs: { kind: "captions" } })]
          )
        : _vm.blobUrl
        ? _c(
            "a",
            {
              staticClass: "media-document d-flex align-center pa-2 rounded",
              attrs: {
                href: _vm.blobUrl,
                download: _vm.mediaFilename || "documento"
              }
            },
            [
              _c("icon-svg", {
                staticClass: "mr-2",
                attrs: {
                  name: _vm.documentIcon,
                  size: "24",
                  color: "grey darken-1"
                }
              }),
              _c("div", { staticClass: "overflow-hidden" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "az-text-primary az-size-12 font-medium text-truncate"
                  },
                  [_vm._v(" " + _vm._s(_vm.mediaFilename || "Documento") + " ")]
                ),
                _c("div", { staticClass: "az-text-secondary az-size-12" }, [
                  _vm._v("Clique para baixar")
                ])
              ]),
              _c("div", { staticClass: "flex-grow-1" }),
              _c("icon-svg", {
                attrs: { name: _vm.icons.download, size: "18", color: "grey" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }